var _path, _path2;
import * as React from "react";
var SvgTemporaryNft = function SvgTemporaryNft(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1 12.006a6.06 6.06 0 0 1 6.053-6.054 6.06 6.06 0 0 1 6.053 6.054 6.06 6.06 0 0 1-6.053 6.053A6.06 6.06 0 0 1 6.1 12.006Zm6.053-4.567a4.572 4.572 0 0 0-4.567 4.567 4.573 4.573 0 0 0 4.567 4.566 4.573 4.573 0 0 0 4.566-4.566 4.573 4.573 0 0 0-4.566-4.567Zm.212 4.479V8.82H10.88v3.713l2.497 2.498 1.051-1.052-2.062-2.061Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.467.137c.33-.183.736-.183 1.066 0l9.935 5.495c.33.182.532.518.532.882v10.972c0 .364-.203.7-.532.882l-9.935 5.495c-.33.183-.736.183-1.066 0l-9.935-5.495A1.012 1.012 0 0 1 1 17.486V6.514c0-.364.203-.7.532-.882L11.467.137ZM12 1.963 2.919 6.986v10.028L12 22.037l9.081-5.023V6.986L12 1.963Z",
    fill: "currentColor"
  })));
};
export default SvgTemporaryNft;